import React from 'react';
import { IFooterProps } from '@cb/athena-widgets-types/dist/props';

declare module 'react' {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            'cbw-footer': IFooterProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}
/**
 * A footer for use across all pages of the app
 */
const GlobalFooter: React.FC = () => {
    return <cbw-footer />;
};

export default GlobalFooter;
